import { defineComponent, ref, onBeforeMount, watch, openBlock, createElementBlock, Fragment, renderList, createVNode, unref, createSlots, withCtx, createElementVNode, toDisplayString } from "vue";
import { CdrChip, IconXLg } from "@rei/cedar";
const _hoisted_1 = {
  class: "pr-pills"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductReviewsPills",
  props: {
    filterStarRating: {}
  },
  emits: ["productReviewsStarsChanged", "metricsClick"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const model = ref();
    const emit = __emit;
    function updateFilter(position) {
      var _a;
      model.value = {
        ...model.value,
        [position]: !((_a = model.value) == null ? void 0 : _a[position])
      };
      emit("productReviewsStarsChanged", model.value);
      emit("metricsClick", {
        linkName: `reviews_ratings pill_${position}`
      });
    }
    onBeforeMount(() => {
      model.value = props.filterStarRating || {};
    });
    watch(() => props.filterStarRating, () => {
      model.value = props.filterStarRating || {};
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [(openBlock(), createElementBlock(Fragment, null, renderList([5, 4, 3, 2, 1], (count) => {
        var _a, _b, _c;
        return createVNode(unref(CdrChip), {
          key: count,
          "aria-controls": "individual-reviews",
          role: "switch",
          "aria-checked": `${((_a = model.value) == null ? void 0 : _a[count]) ?? false}`,
          "data-ui": `stars-pill-${count}`,
          "aria-pressed": (_b = model.value) == null ? void 0 : _b[count],
          onClick: ($event) => updateFilter(count)
        }, createSlots({
          default: withCtx(() => [createElementVNode("span", null, toDisplayString(count) + " star" + toDisplayString(count > 1 ? "s" : ""), 1)]),
          _: 2
        }, [((_c = model.value) == null ? void 0 : _c[count]) ? {
          name: "icon-right",
          fn: withCtx(() => [createVNode(unref(IconXLg), {
            size: "small"
          })]),
          key: "0"
        } : void 0]), 1032, ["aria-checked", "data-ui", "aria-pressed", "onClick"]);
      }), 64))]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=ProductReviewsPills2.mjs.map
